<template>
  <div class="col-12 top-24">
    <div class="row mb-2">
      <div class="col-12">
        <button class="btn-primary" style="padding: 1px 5px; margin-right: 5px; margin-top: 2px;" @click="exportToExcel">
          Экспорт
        </button>
      </div>
    </div>
    <vue-good-table ref="myTable"
                    :columns="columns"
                    :rows="formattedPartnerWasteReports"
                    :pagination-options="{
              enabled: true,
              perPage: 25
          }"
                    :search-options="{
              enabled: true
          }"
                    @search="onSearch"
    />
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next';
import * as XLSX from 'xlsx/xlsx.mjs';
import saveAs from 'file-saver';

export default {
  components: { VueGoodTable },
  props: {
    startDate: { type: String, default: '' },
    endDate: { type: String, default: '' }
  },
  data() {
    return {
      currentSearchTerm: '',
      columns: [
        {
          label: 'Наименование отхода',
          field: 'WasteType',
        },
        {
          label: 'Код по ФККО',
          field: 'FKKOCode',
        },
        {
          label: 'Контрагент',
          field: 'CompanyName',
        },
        {
          label: 'ИНН Контрагента',
          field: 'CompanyINN',
          type: 'string'
        },
        {
          label: '№ договора',
          field: 'ContractName',
        },
        {
          label: 'Принято на объект, всего тонн',
          field: 'WholeWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на утилизацию (м3)',
          field: 'RecyclingVolume',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на утилизацию (тонн)',
          field: 'RecyclingWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на захоронение (м3)',
          field: 'DumpingVolume',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
        {
          label: 'Направлено на захоронение (тонн)',
          field: 'DumpingWeight',
          type: 'number',
          formatFn: this.formatNumberDisplay
        },
      ],
      excelHeaders: [
        'Наименование отхода',
        'Код по ФККО',
        'Контрагент',
        'ИНН Контрагента',
        '№ договора',
        'Принято на объект, всего тонн',
        'Направлено на утилизацию (м3)',
        'Направлено на утилизацию (тонн)',
        'Направлено на захоронение (м3)',
        'Направлено на захоронение (тонн)'
      ],
      excelNumberFormats: ['', '', '', '', '', '#,##0.0000', '#,##0.0000', '#,##0.0000', '#,##0.0000', '#,##0.0000']
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    PartnerWasteReports() {
      return this.$store.state.eco_partner_waste_reports
    },
    formattedPartnerWasteReports() {
      return this.PartnerWasteReports.map(item => ({
        ...item,
        CompanyINN: this.formatAsText(item.CompanyINN),
        WholeWeight: this.formatNumberDisplay(item.WholeWeight),
        RecyclingVolume: this.formatNumberDisplay(item.RecyclingVolume),
        RecyclingWeight: this.formatNumberDisplay(item.RecyclingWeight),
        DumpingVolume: this.formatNumberDisplay(item.DumpingVolume),
        DumpingWeight: this.formatNumberDisplay(item.DumpingWeight),
        FKKOCode: this.formatAsText(item.FKKOCode),
      }));
    },
    excelFileName() {
      const now = new Date();
      const dateStr = now.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }).replace(/\./g, '-');
      const timeStr = now.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).replace(/:/g, '-');
      return `отходы_отчет_${dateStr}_${timeStr}.xlsx`;
    },
    filteredForExport() {
      if (!this.currentSearchTerm) {
        return this.formattedPartnerWasteReports;
      }
      const term = this.currentSearchTerm.toLowerCase();
      return this.formattedPartnerWasteReports.filter(row => {
        return Object.values(row).some(val => {
          if (val === null || val === undefined) return false;
          return String(val).toLowerCase().includes(term);
        });
      });
    }
  },
  methods: {
    exportToExcel() {
      const rows = [];

      // Строка 1: Период
      if (this.startDate && this.endDate) {
        const periodStr = `Период: c ${this.formatDateDisplay(this.startDate)} по ${this.formatDateDisplay(this.endDate)}`;
        rows.push([periodStr, '', '', '', '', '', '', '', '', '']);
      }

      // Строка 2: Отбор
      if (this.currentSearchTerm) {
        const filterStr = `Отбор: "${this.currentSearchTerm}"`;
        rows.push([filterStr, '', '', '', '', '', '', '', '', '']);
      }

      // Строка 3: пустая
      rows.push(['', '', '', '', '', '', '', '', '', '']);

      // Строка 4: заголовки колонок
      rows.push([...this.excelHeaders]);

      // Строки 5+: данные
      this.filteredForExport.forEach(row => {
        const exportRow = [
          row.WasteType || '',
          this.formatAsText(row.FKKOCode),
          row.CompanyName || '',
          this.formatAsText(row.CompanyINN),
          row.ContractName || '',
          Number(row.WholeWeight) || 0,
          Number(row.RecyclingVolume) || 0,
          Number(row.RecyclingWeight) || 0,
          Number(row.DumpingVolume) || 0,
          Number(row.DumpingWeight) || 0
        ];
        rows.push(exportRow);
      });

      // Создаём workbook
      const ws = XLSX.utils.aoa_to_sheet(rows);

      // Применяем числовые форматы к колонкам
      const range = XLSX.utils.decode_range(ws['!ref']);
      for (let C = 0; C < this.excelNumberFormats.length; C++) {
        if (this.excelNumberFormats[C]) {
          const col = XLSX.utils.encode_col(C);
          for (let R = 4; R <= range.e.r; R++) { // начинаем со строки 5 (индекс 4) — строки данных
            const cell = ws[`${col}${R + 1}`];
            if (cell && typeof cell.v === 'number') {
              cell.z = this.excelNumberFormats[C];
            }
          }
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Отчет по отходам');

      const buf = XLSX.write(wb, {
        type: 'buffer',
        bookType: 'xlsx',
        mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, this.excelFileName);
    },
    onSearch({ searchTerm }) {
      this.currentSearchTerm = searchTerm;
    },
    formatAsText(value) {
      if (!value) return '';
      return String(value);
    },
    formatNumberDisplay(value) {
      if (value === null || value === undefined) return '0';
      const num = Number(value);
      if (isNaN(num)) return '0';
      return this.removeTrailingZeros(num.toFixed(4));
    },
    removeTrailingZeros(numberString) {
      return numberString.replace(/\.?0+$/, '');
    },
    formatDateDisplay(dateStr) {
      if (!dateStr) return '';
      const [y, m, d] = dateStr.split('-');
      return `${d}.${m}.${y}`;
    }
  }
};
</script>
